import _ from 'underscore'
import React from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import useGroups from 'hooks/useGroups'
import NotFound from 'pages/NotFound'
import GroupMetricForm from 'pages/shared/GroupMetricForm'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditGroupMetric = () => {
  const { groups, areGroupsLoaded } = useGroups()
  const { id } = useParams()

  if (!areGroupsLoaded) {
    return <LoadingSinglePanePage />
  }

  const groupMetric = _.find(groups, (group) => group.groupId.toString() === id)

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Group Metric</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        {
          groupMetric ? (
            <GroupMetricForm
              saveMethod="update"
              groupMetric={groupMetric}
            />
          ) : <NotFound />
        }
      </S.SinglePanePage>
    </>
  )
}

export default EditGroupMetric

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
